export enum AccountIdType {
  AccountId = 'AccountId',
  InvitedAccountId = 'InvitedAccountId',
}
